import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import { useAuth } from '../../auth/auth-provider';
import { useUserEcommerceSettings } from './hooks/use-ecommerce-settings';

interface EcommerceSettingsContext {
  user: ReturnType<typeof useUserEcommerceSettings>;
}

export const ecommerceSettingsContext = createContext<EcommerceSettingsContext | null>(null);

export const EcommerceSettingsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const user = useUserEcommerceSettings();
  const { fetchUserSettings } = user;

  useEffect(() => {
    if (isAuthenticated) {
      fetchUserSettings({});
    }
  }, [isAuthenticated, fetchUserSettings]);

  return <ecommerceSettingsContext.Provider value={{ user }}>{children}</ecommerceSettingsContext.Provider>;
};

export default EcommerceSettingsProvider;

export const useEcommerceSettings = () => {
  const context = useContext(ecommerceSettingsContext);

  if (!context) {
    throw new Error('useEcommerceSettings must be used within a EcommerceSettingsProvider');
  }

  return context;
};
